/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ProjectInKindSupport {
  NotRelevant = 'NotRelevant',
  TrainingAndExtension = 'TrainingAndExtension',
  TechnologyTransfer = 'TechnologyTransfer',
  AlternativeLivelihoodsActivities = 'AlternativeLivelihoodsActivities',
  LandscapeRestoration = 'LandscapeRestoration',
  EnhancingAccessToFinance = 'EnhancingAccessToFinance',
  Other = 'Other',
}
